import Component from '@glimmer/component';
import { guidFor } from '@ember/object/internals';
import { modifier } from 'ember-modifier';
import { on } from '@ember/modifier';

const autofocus = modifier(
  (element: HTMLInputElement, [focusOnInsert]: [boolean]) => {
    if (focusOnInsert) {
      element.focus();
    }
  },
);

interface DeInputComponentArgs {
  value?: string;
  focusOnInsert: boolean;
  onEnter?: (value: string) => Promise<void> | void;
  onChange?: (value: string) => Promise<void> | void;
  onUpArrow?: (event: KeyboardEvent) => Promise<void> | void;
  onDownArrow?: (event: KeyboardEvent) => Promise<void> | void;
  onTab?: (event: KeyboardEvent) => Promise<void> | void;
}

export default class DeInputComponent extends Component<DeInputComponentArgs> {
  inputId = `de-input-${guidFor(this)}`;

  handleChange = (event: Event) => {
    if (event.key === 'Enter') {
      // The Enter key is already handled in handleKeyDown.  We have
      // already been tracking the input value, so we don't need to do
      // anything here.

      return;
    }

    const input = event.target as HTMLInputElement;
    return this.args.onChange?.(input.value);
  };

  handleKeyDown = (event: KeyboardEvent) => {
    const input = event.target as HTMLInputElement;
    switch (event.key) {
      case 'ArrowUp':
        return this.args.onUpArrow?.(event);
      case 'ArrowDown':
        return this.args.onDownArrow?.(event);
      case 'Tab':
        return this.args.onTab?.(event);
      case 'Enter':
        return this.args.onEnter?.(input.value);
    }
  };

  <template>
    <input
      ...attributes
      type='text'
      id={{this.inputId}}
      class='form-control'
      value={{@value}}
      {{on 'input' this.handleChange}}
      {{on 'keydown' this.handleKeyDown}}
      {{autofocus @focusOnInsert}}
    />
  </template>
}
